import React from "react";
import AdmAssignMentor from "../../components/AdminTabs/AdminAssignMentor/AdmAssignMentor";

const AddStudent = () => {
  return (
    <div>
      <AdmAssignMentor/>
    </div>
  );
};

export default AddStudent;
